import Axios from 'helpers/http'

const OneMap = new Axios('https://developers.onemap.sg/commonapi')
class OneMapAPI {
  static async getCoords(searchVal, returnGeom = 'Y', getAddrDetails = 'Y') {
    return OneMap.httpGet(
      `/search?searchVal=${searchVal}&returnGeom=${returnGeom}&getAddrDetails=${getAddrDetails}`,
      {},
      true
    )
  }
}

export default OneMapAPI
